import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BMechanismFetchListCard } from './BMechanismFetchListCard'

export const BMechanismPopperListCard = defineComponent({
  name: 'BMechanismPopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids }} tippyConfig={getAsyncListTippyConfig()} component={BMechanismFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
